module.exports = __webpack_public_path__ + "static/media/note-5.0a59887c.svg";